module.exports = __webpack_public_path__ + "img/ad.367b58cb.svg";